export const emptyRacks = {
  A: {
    spaceArr: createEmptySpaceArr(0),
    used: 0,
    barcodes: createEmptySpaceArr(15),
    together: {}
  },
  B: {
    spaceArr: createEmptySpaceArr(0),
    used: 0,
    barcodes: createEmptySpaceArr(15),
    together: {}
  },
  C: {
    spaceArr: createEmptySpaceArr(0),
    used: 0,
    barcodes: createEmptySpaceArr(15),
    together: {}
  }
}

export function createEmptySpaceArr(value) {
  return [...Array(6)].map(e => Array(8).fill(value));
}

